<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { BaseBannerAlert } from '@cplug/design-system'
import { BannerAlertType } from '@cplug/design-system/components/props'
import { consumeTwoFactorBackupLoginAlert } from '../../composables/useTwoFactorPostLoginNotice'
import { useTwoFactorPostLoginNoticeTranslation } from '../../composables/TwoFactorPostLoginNotice.i18n'

const { t } = useTwoFactorPostLoginNoticeTranslation()

const showBackupLoginAlert = ref(false)

onMounted(() => {
  showBackupLoginAlert.value = consumeTwoFactorBackupLoginAlert()
})
</script>

<template>
  <BaseBannerAlert
    v-if="showBackupLoginAlert"
    class="mb-4"
    :title="t('BackupLoginAlertTitle')"
    :body-text="t('BackupLoginAlertBody')"
    :type="BannerAlertType.Warning"
    :dismiss="true"
    @dismiss="showBackupLoginAlert = false"
  />
</template>
